import * as React from "react";
import { Card, Button, Popconfirm, message, Tag } from "antd";
import { Fragment } from "react";
import ChangePasswordForm from "./ChangePasswordForm";
import ChangePassword from "../../mutations/ChangePassword";
import SendWelcomeMail from "../../mutations/SendWelcomeMail";
import EditUserFields from "./EditUserFields";
import UpdateUser from "../../mutations/UpdateUser";
import { Redirect } from "react-router";
import DeleteUser from "src/mutations/DeleteUser";
import LockUser from "src/mutations/LockUser";
export interface User {
  id: string;
  email: string;
  ldapDN?: string | null;
  name?: string;
  firstName?: string | null;
  surName?: string | null;
  phone?: string | null;
  postalCode?: string | null;
  city?: string | null;
  street?: string | null;
  roles?: Array<{
    name: string;
  }>;
  lastLoginAt?: string | null;
  lockedAt?: string | null;
}

export interface Props {
  admin: boolean;
  user: User | null;
  loading?: boolean;
  add?: boolean;
}

export interface State {
  deleted: boolean;
  createdId: string | null;
}

const cardStyle = { marginTop: 30, maxWidth: 750 };

export default class UserDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { deleted: false, createdId: null };
  }

  render() {
    if (!this.props.add) {
      if (!this.props.loading && this.state.deleted) {
        return <Redirect to="/users" />;
      }
      if (!this.props.loading && this.props.user == null) {
        message.error("User not found");
        return <Redirect to="/" />;
      }
    } else {
      if (this.state.createdId) {
        return <Redirect to={"/users/" + this.state.createdId} />;
      }
    }

    return (
      <Fragment>
        <Card
          loading={this.props.loading}
          title={
            this.props.loading
              ? "Loading..."
              : this.props.user
              ? `${this.props.user.firstName || this.props.user.email} ${
                  this.props.user.surName
                }`
              : "New User"
          }
          extra={
            <>
              {this.props.user && this.props.user.lockedAt && (
                <Tag color="red">Locked</Tag>
              )}
            </>
          }
          style={cardStyle}
        >
          {(this.props.add || this.props.user) && (
            <>
              <UpdateUser
                userId={this.props.user ? this.props.user.id : ""}
                refetchAll={this.props.admin}
              >
                {update => (
                  <EditUserFields
                    admin={this.props.admin}
                    user={this.props.user}
                    onSubmit={v =>
                      update({
                        variables: {
                          id: this.props.user ? this.props.user.id : null,
                          data: {
                            ...v,
                            roles: {
                              set: v.roles.map(r => ({ name: r }))
                            }
                          }
                        }
                      }).then(
                        r =>
                          this.props.add &&
                          r &&
                          r.data &&
                          r.data.upsertUser &&
                          r.data.upsertUser.id &&
                          this.setState({ createdId: r.data.upsertUser.id })
                      )
                    }
                  />
                )}
              </UpdateUser>
            </>
          )}
        </Card>
        {!this.props.add && !this.props.admin && (
          <Card
            loading={this.props.loading}
            title="Change password"
            style={cardStyle}
          >
            <ChangePassword>
              {changePw => (
                <ChangePasswordForm
                  onSubmit={v => changePw({ variables: v })}
                />
              )}
            </ChangePassword>
          </Card>
        )}
        {!this.props.add && this.props.admin && (
          <Card
            className="danger"
            loading={this.props.loading}
            title="Admin"
            style={cardStyle}
          >
            {this.props.user && (
              <>
                <SendWelcomeMail>
                  {send =>
                    this.props.user && (
                      <Popconfirm
                        title={`Send welcome mail to ${this.props.user.email}?`}
                        onConfirm={() =>
                          this.props.user &&
                          this.props.user.email &&
                          send({
                            variables: { mail: this.props.user.email }
                          }).then(() =>
                            message.success(
                              `Welcome mail sent to ${this.props.user!.email}`
                            )
                          )
                        }
                        onCancel={() => console.log("cancel")}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button>(Re)Send welcome mail</Button>
                      </Popconfirm>
                    )
                  }
                </SendWelcomeMail>
                <LockUser>
                  {lock =>
                    this.props.user && this.props.user.lockedAt ? (
                      <Popconfirm
                        title="Unlock this user?"
                        onConfirm={() =>
                          this.props.user &&
                          lock({
                            variables: {
                              id: this.props.user.id,
                              locked: false
                            }
                          }).then(() =>
                            message.success(
                              `User ${this.props.user!.name} has been unlocked`
                            )
                          )
                        }
                        onCancel={() => console.log("cancel")}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger">
                          <strong>Un</strong>
                          lock account
                        </Button>
                      </Popconfirm>
                    ) : (
                      <Popconfirm
                        title="Lock this user? He will not be able to login!"
                        onConfirm={() =>
                          this.props.user &&
                          lock({
                            variables: {
                              id: this.props.user.id,
                              locked: true
                            }
                          }).then(() =>
                            message.success(
                              `User ${this.props.user!.name} has been locked!`
                            )
                          )
                        }
                        onCancel={() => console.log("cancel")}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger">Lock account</Button>
                      </Popconfirm>
                    )
                  }
                </LockUser>

                <DeleteUser>
                  {delUser => (
                    <Popconfirm
                      title="Delete this user? This action is permanent!"
                      onConfirm={() =>
                        this.props.user &&
                        delUser({
                          variables: { id: this.props.user.id }
                        }).then(() =>
                          this.setState({ deleted: true }, () =>
                            message.success(`${this.props.user!.name} deleted`)
                          )
                        )
                      }
                      onCancel={() => console.log("cancel")}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="danger">Delete account</Button>
                    </Popconfirm>
                  )}
                </DeleteUser>
              </>
            )}
          </Card>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserDetails/UserDetails.tsx